import { useState } from "react"
import { DateTime } from "luxon"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { StandardButton } from "../../../../../shared/components/buttons/StandardButton"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { StandardTabs } from "../../../../../shared/components/tabs/StandardTabs"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { DayMenuDialog } from "../components/dayMenuDialog/DayMenuDialog"
import { MERCHANT_REPORTS_ROUTE } from "../../../../../constants/routes"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { MenuPlanningTab, MENU_PLANNING_TAB_ORDER } from "../menuPlanningTabs"
import { MenuCalendar } from "./MenuCalendar"
import { Menus } from "./Menus"
import { DigitalSignage } from "./DigitalSignage"
import { Stack } from "@mui/material"
import { WeekMenuButton } from "../components/WeekMenuButton"
import { useDateTime } from "../../../../localization/useDateTime"

export function MenuPlanning() {
    const { l10n } = useAppLocalization()

    const dateTimeFactory = useDateTime()
    const today = dateTimeFactory.now()
    const [dayMenuModalState, setDayMenuModalState] = useState<{
        show: boolean
        menuId: null | number
        dateInfo: DateTime
    }>({
        show: false,
        menuId: null,
        dateInfo: today,
    })

    const tabConfigs: Record<MenuPlanningTab, { label: string; component: JSX.Element }> = {
        [MenuPlanningTab.CALENDAR]: {
            label: l10n.getString("merchant-menu-planning-tab-calendar"),
            component: <MenuCalendar />,
        },
        [MenuPlanningTab.MENUS]: {
            label: l10n.getString("merchant-menu-planning-tab-menus"),
            component: <Menus />,
        },
        [MenuPlanningTab.DIGITAL_SIGNAGE]: {
            label: l10n.getString("merchant-menu-planning-tab-digital-signage"),
            component: <DigitalSignage />,
        },
    }

    const tabs = MENU_PLANNING_TAB_ORDER.map((tab) => tabConfigs[tab])

    return (
        <>
            <LocalizedStrict id="merchant-menu-planning-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.MENU_PLANNING}
                    title="Menu planning"
                    rightElement={
                        <Stack direction="row" spacing="2rem">
                            <WeekMenuButton />
                            <LocalizedStrict id="merchant-menu-planning-table-create-button">
                                <StandardButton
                                    onClick={() => setDayMenuModalState((prev) => ({ ...prev, show: true }))}
                                >
                                    Create menu
                                </StandardButton>
                            </LocalizedStrict>
                        </Stack>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_REPORTS_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-menu-planning">
                            <Breadcrumb>Menu Planning</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <StandardTabs tabs={tabs} />
            {dayMenuModalState.show && (
                <DayMenuDialog
                    open={dayMenuModalState.show}
                    menuId={dayMenuModalState.menuId}
                    dateInfo={dayMenuModalState.dateInfo}
                    onClose={() => setDayMenuModalState((prev) => ({ ...prev, show: false }))}
                />
            )}
        </>
    )
}
